import { gql } from '@apollo/client';

export const GET_EXCEPTIONS = gql(/* GraphQL */ `
  query GetExceptions($limit: Int = 25, $offset: Int = 0, $filter: ExceptionFilterInput, $orderBy: ExceptionOrderByInput, $customsTerritories: [String!]!) {
    exception {
      list(
        limit: $limit,
        offset: $offset,
        filter: $filter,
        orderBy: $orderBy,
        customsTerritories: $customsTerritories
      ) {
        items {
          id
          alias
          customsTerritory
          description
          guidance
          status
          targetResolutionDate
          resolutionType
          creationDate
          assignee {
            id
            name
            email
            avatarUrl
          }
          consignment {
            id
            billOfLadingNbr
            originCountry
            countryOfImport
            dischargeCountry
            productDivisions
            modeOfTransport
          }
        }
        pageInfo {
          totalCount
          status
          message
        }
      }
    }
  }
`);

export const ASSIGN_EXCEPTION = gql`
  mutation AssignException($exceptionId: ID!, $assigneeId: ID) {
    assignException(input: { exceptionId: $exceptionId, assigneeId: $assigneeId }) {
      exception {
        id
        assignee {
          id
          name
          email
        }
      }
    }
  }
`;

export const RETRY_EXCEPTION = gql`
  mutation RetryException($exceptionId: ID!, $retryComment: String) {
    retryException(input: { exceptionId: $exceptionId, retryComment: $retryComment }) {
      exception {
        id
        status
      }
    }
  }
`;

export const ADD_COMMENT_TO_EXCEPTION = gql`
  mutation AddCommentToException($exceptionId: ID!, $content: String!) {
    addCommentToException(input: { exceptionId: $exceptionId, content: $content }) {
      exception {
        id
        status
        assignee { id name email }
      }
    }
  }
`;

export const UPDATE_EXCEPTION_STATUS_TO_OPEN = gql`
  mutation UpdateExceptionStatusToOpen($exceptionId: ID!) {
    updateExceptionStatusToOpen(input: { exceptionId: $exceptionId }) {
      exception {
        id
        status
      }
    }
  }
`;

export const UPDATE_EXCEPTION_STATUS_TO_IN_PROGRESS = gql`
  mutation UpdateExceptionStatusToInProgress($exceptionId: ID!) {
    updateExceptionStatusToInProgress(input: { exceptionId: $exceptionId }) {
      exception {
        id
        status
      }
    }
  }
`;

export const GET_EXCEPTION_TYPES = gql`
  query GetExceptionTypes($customsTerritories: [String!]!) {
    exception {
      types(customsTerritories: $customsTerritories) {
        code
        description
        guidance
      }
    }
  }
`;

export const LIST_EXCEPTION_COUNTRIES = gql`
  query ListExceptionCountries($fieldType: String!, $customsTerritories: [String!]!) {
    exception {
      listCountries(fieldType: $fieldType, customsTerritories: $customsTerritories)
    }
  }
`;

export const GET_EXCEPTION = gql`
  query GetException($id: ID!) {
    exception {
      get(id: $id) {
        id
        alias
        customsTerritory
        description
        guidance
        status
        targetResolutionDate
        resolutionType
        creationDate
        stepTitle
        retryable
        assignee {
          id
          name
          email
          avatarUrl
        }
        consignment {
          id
          billOfLadingNbr
          originCountry
          countryOfImport
          dischargeCountry
          productDivisions
          modeOfTransport
          equipmentVehicle {
            id
            voyageNumber
          }
        }
        auditTrail(limit: 25, offset: 0) {
          pageInfo {
            totalCount
          }
        }
        messages {
          id
          timestamp
          code
          summary
          status
          contextResolutionGroupingKey
          context
        }
      }
    }
  }
`;

export const GET_EXCEPTION_FIELDS = gql `
  fragment ExceptionFields on Exception {
    id
    alias
    customsTerritory
    description
    guidance
    status
    targetResolutionDate
    resolutionType
    creationDate
    stepName
    stepTitle
    assignee {
      id
      name
      email
      avatarUrl
    }
    consignment {
      id
      billOfLadingNbr
      carrier
      originCountry
      countryOfImport
      dischargeCountry
      productDivisions
      modeOfTransport
      equipmentVehicle {
        id
        plannedDischargeDate
        modeOfTransport
        voyageNumber
        carrier
      }
      expectedShipmentCount
      actualShipmentCount
      workflowInstance {
        workflowInstanceId
        workflowDefinitionName
        workflowDefinitionURI
      }
    }
    auditTrail(limit: 25, offset: 0) {
      # items {
      #   id
      #   timestamp
      #   user { id name email }
      #   targetUser { id name email }
      #   fromStatus
      #   toStatus
      #   content
      # }
      pageInfo {
        totalCount
      }
    }
    messages {
      id
      timestamp
      code
      summary
      status
      contextResolutionGroupingKey
      context
    }
  }
`;

export const GET_EXCEPTION_AUDIT_TRAIL = gql`
  query GetExceptionAuditTrail($id: ID!, $limit: Int = 25, $offset: Int = 0) {
    exception {
      get(id: $id) {
        id
        auditTrail(limit: $limit, offset: $offset) {
          items {
            id
            timestamp
            user { 
              id 
              name 
              email 
            }
            targetUser { 
              id 
              name 
              email 
            }
            fromStatus
            toStatus
            content
          }
          pageInfo {
            totalCount
            status
            message
          }
        }
      }
    }
  }
`;
